import request from "./request";

const MCQService = {
    GetAll: async (id, context, signal) => {
        return await request.sendRequest(`/mcq/all/${id}`, context.token, signal);
    },
    BulkSave: async (payload, context, signal) => {
        return await request.sendPostRequest(`/mcq/bulk`, payload, context, signal);
    },
    Save: async (payload, context, signal) => {
        return await request.sendPostRequest(`/mcq`, payload, context, signal);
    },
    Remove: async (id, context) => {
        return await request.sendDeleteRequest(`/mcq/${id}`, context.token);
    },
    RemoveQuestions: async (id, context) => {
        return await request.sendDeleteRequest(`/mcq/questions/${id}`, context.token);
    },
};

export default MCQService;
